import { useEffect } from "react";
import PageHeader from "../components/pages/about/PageHeader";
import WhoWeAre from "../components/pages/about/WhoWeAre";
import Mission from "../components/pages/about/Mission";
import WhyAwardsMatter from "../components/pages/about/WhyAwardsMatter";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Update meta tags
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Travel Bloggers | About');
    }

    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute('content', 'Travel Bloggers | About');
    }

    const twitterTitle = document.querySelector('meta[name="twitter:description"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', 'Travel Bloggers | About');
    }

    // Update page title
    document.title = 'Travel Bloggers | About';
  }, []);

  return (
    <>
      <PageHeader />
      <WhoWeAre />
      <Mission />
      <WhyAwardsMatter />
    </>
  );
};

export default About;